/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

import { LANG } from "config/const";

export default function themeTypography(theme, lang) {
  return {
    fontFamily: lang === LANG.EN ? "BulgariType" : "Noto Sans Thai",
    fontSize: 12,
    htmlFontSize: 14,
    h7: {
      fontSize: "0.69rem",
      color: theme.darkTextPrimary,
      fontWeight: 700,
    },
    h6: {
      fontWeight: 700,
      color: theme.darkTextPrimary,
      fontSize: "0.75rem",
    },
    h5: {
      fontWeight: 700,
      color: theme.darkTextPrimary,
      fontSize: "0.875rem",
    },
    h4: {
      fontSize: "1rem",
      color: theme.darkTextPrimary,
      fontWeight: 400,
    },
    h3: {
      fontSize: "1rem",
      color: theme.darkTextPrimary,
      fontWeight: 400,
    },
    h2: {
      fontSize: "1.5rem",
      color: theme.darkTextPrimary,
      fontWeight: 700,
    },
    h1: {
      fontSize: "2rem",
      color: theme.darkTextPrimary,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: "1.5rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "0.8rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    subtitle3: {
      fontSize: "0.63rem",
      color: theme.darkTextPrimary,
      fontWeight: 400,
    },
    subtitle4: {
      fontSize: "0.5rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    body1: {
      fontSize: "1rem",
      color: theme.darkTextPrimary,
      fontWeight: 400,
    },
    body2: {
      fontSize: "1.2rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    body3: {
      fontSize: "1rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    body4: {
      fontSize: "0.94rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    body5: {
      fontSize: "0.75rem",
      color: theme.darkTextSecondary,
      fontWeight: 400,
    },
    btn: {
      fontSize: "0.82rem",
    },
  };
}
